// 🔴 FORCE DISABLE "Please add more videos" ALERT (Pipeline fix)
(function () {
  const originalAlert = window.alert;
  window.alert = function (message) {
    if (
      typeof message === 'string' &&
      message.toLowerCase().includes('add more videos')
    ) {
      console.warn('Pipeline video alert blocked:', message);
      return;
    }
    originalAlert(message);
  };
})();


/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


//(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  //document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    //var variant = event.detail.variant;
   // var container = event.target;
   // if (variant) {
    //  console.log('Container ———————— ↓');
    //  console.log(container); 
    //  console.log('Variant —————————— ↓');
    //  console.log(variant);
      // ... update some element on the page
   // }
  //});

  //document.addEventListener('theme:cart:change', function(event) {
    //var cart = event.detail.cart;
   // if (cart) {
     // console.log('Cart ———————————— ↓');
     // console.log(cart);
      // ... update an app or a custom shipping caluclator
   // }
  //});
  // Fired when page loads to update header values
 // document.addEventListener('theme:cart:init', (e) => {
    //console.log('theme:cart:init');
   // console.log(e);
  //});

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
//})();

//Slick Slider
jQuery('.shop-slider').slick({
    dots: false, // Dots ko hata diya
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="custom-slick-prev" aria-label="Previous">&#8249;</button>',
    nextArrow: '<button type="button" class="custom-slick-next" aria-label="Next">&#8250;</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false // Dots responsive mein bhi off
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
//Popup Code
   document.addEventListener("DOMContentLoaded", function () {
    const popup = document.getElementById("sizeGuidePopup");
    const openBtn = document.querySelector(".size-guide-trigger");
    const closeBtn = document.querySelector(".size-guide-close");

    if (openBtn && popup && closeBtn) {
      openBtn.addEventListener("click", function () {
        popup.style.display = "block";
      });

      closeBtn.addEventListener("click", function () {
        popup.style.display = "none";
      });

      window.addEventListener("click", function (e) {
        if (e.target === popup) {
          popup.style.display = "none";
        }
      });
    }
  });

//Swiper slider Code
window.addEventListener('load', function () {
  if (typeof Swiper === 'undefined') return;

  const isMobile = window.matchMedia('(max-width: 1024px)').matches;
  const body = document.body;
  let swiper;

  function playVideo(slide) {
    if (!slide) return;
    const video = slide.querySelector('.swiper-video');
    if (video) video.play().catch(() => {});
  }

  swiper = new Swiper('.verticalSwiper', {
    direction: 'vertical',
    slidesPerView: 1,
    speed: 900,
    resistanceRatio: 0,
    allowTouchMove: true,

    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true
    },

    on: {
      init(swiper) {
        playVideo(swiper.slides[swiper.activeIndex]);
        if (!isMobile) {
          body.style.overflow = 'hidden';
        }
      },

      slideChange(swiper) {
        document.querySelectorAll('.swiper-video').forEach(v => {
          v.pause();
          v.currentTime = 0;
        });

        playVideo(swiper.slides[swiper.activeIndex]);

        if (swiper.isEnd) {
          if (isMobile) {
            // Mobile logic
            setTimeout(() => {
              const footer = document.querySelector('footer');
              if (footer) {
                footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 200);
          } else {
            // Desktop logic - SIMPLE
            body.style.overflow = 'auto';
          }
        } else {
          if (!isMobile) {
            body.style.overflow = 'hidden';
          }
        }
      }
    }
  });

  // Desktop: Handle scroll back to swiper
  if (!isMobile) {
    let lastScrollTop = 0;
    
    window.addEventListener('scroll', function() {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      const swiperEl = document.querySelector('.verticalSwiper');
      
      if (!swiperEl) return;
      
      const rect = swiperEl.getBoundingClientRect();
      
      // If scrolling UP and swiper is coming into view
      if (st < lastScrollTop && rect.top < 100 && rect.top > -50) {
        // Switch back to swiper mode
        if (swiper.isEnd) {
          body.style.overflow = 'hidden';
          
          // Small delay for smooth transition
          setTimeout(() => {
            swiper.slideTo(swiper.slides.length - 1, 0);
          }, 50);
        }
      }
      
      lastScrollTop = st <= 0 ? 0 : st;
    });
  }
});
  /* ===== REMOVE PDP VIDEO PLAY BUTTON (PIPELINE) ===== */
document.addEventListener("DOMContentLoaded", function () {

  function removePDPPlayButton() {
    document.querySelectorAll('.pdp-video-play').forEach(btn => {
      btn.remove();
    });
  }

  // Initial run
  removePDPPlayButton();

  // Agar theme dobara inject kare
  const observer = new MutationObserver(removePDPPlayButton);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
/* ===== PDP VIDEO CLOSE BUTTON FUNCTIONALITY ===== */
document.addEventListener("DOMContentLoaded", function () {

  function setupPDPVideoClose() {
    const videoWrapper = document.querySelector('.pdp-video-overlay');
    if (!videoWrapper) return;

    // Agar cross already exist na karta ho
    if (!videoWrapper.querySelector('.pdp-video-close')) {

      const closeBtn = document.createElement('div');
      closeBtn.className = 'pdp-video-close';
      closeBtn.innerHTML = '&times;';

      closeBtn.addEventListener('click', function () {
        videoWrapper.style.display = 'none';

        const video = videoWrapper.querySelector('video');
        if (video) {
          video.pause();
        }
      });

      videoWrapper.appendChild(closeBtn);
    }
  }

  // Initial run
  setupPDPVideoClose();

  // Pipeline dobara inject kare to
  const observer = new MutationObserver(setupPDPVideoClose);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.pdp-video-close').forEach(btn => {
    btn.style.top = '';
    btn.style.right = '';
  });
});
/* FORCE PDP VIDEO CLOSE BUTTON POSITION */
function forceVideoClosePosition() {
  document.querySelectorAll('.pdp-video-close').forEach(btn => {
    btn.style.top = '-4px';
    btn.style.right = '-4px';
    btn.style.zIndex = '9999';
  });
}

// Initial run
document.addEventListener('DOMContentLoaded', forceVideoClosePosition);

// Pipeline slider changes / re-renders
const pdpObserver = new MutationObserver(forceVideoClosePosition);
pdpObserver.observe(document.body, {
  childList: true,
  subtree: true
});
// ✅ PDP MINI VIDEO CLICK → OPEN POPUP
document.addEventListener("DOMContentLoaded", function () {

  const modal = document.getElementById("pdp-video-modal");
  const video = modal ? modal.querySelector("video") : null;

  function openVideoPopup() {
    if (!modal || !video) return;

    modal.style.display = "flex";
    modal.offsetHeight; // reflow
    modal.classList.add("is-open");
    video.play().catch(() => {});
  }

  // ▶ Play button
  document.querySelectorAll(".pdp-video-play").forEach(btn => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      openVideoPopup();
    });
  });

  // 🎥 Mini overlay video click
  document.querySelectorAll(".pdp-mini-video").forEach(vid => {
    vid.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      openVideoPopup();
    });
  });

});
